document.addEventListener('change', (event) => {
  const control = event.target;
  if (!(control instanceof HTMLSelectElement) || control.id !== 'KhlganSort') return;
  control.form?.requestSubmit();
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('.khlgan-site-header__mobile[open]');
  if (!menu) return;
  menu.open = false;
  menu.querySelector('summary')?.focus();
});
